import { useState } from "react";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import QuickLink from "../utils/QuickLink";
import MunCommittees from "../utils/MunCommittees";
import MunTestimonial from "../utils/MunTestimonial";
import HeaderMUN from "../Component/HeaderMUN";
import FooterMun from "../Component/FooterMun";
import MunGallery from "../Component/MunGallery";
import { munCommitteeData, munTestimonialData } from "../utils/MunCommitteeTestimonial";


const S3_url = "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com"


const NcsMun = () => {
  const [showTestimonialFull, setShowTestimonialFull] = useState(false);

  const munButtons = [
    { title: "Register Now", href: "#register-now" },
    { title: "Explore Committees 2026", href: "#committees" },
    { title: "Schedule", href: "#schedule" },
    { title: "Download Brochure", href: "#brochure" },
    { title: "Contact", href: "#contact" },
    { title: "Previous MUNs", href: "#previous-muns" },
    { title: "Social Media Pages", href: "#social-media" },
  ];

  const skillsDeveloped = [
    { title: "Public Speaking" },
    { title: "Research" },
    { title: "Negotiation" },
    { title: "Diplomacy" },
    { title: "Leadership" },
    { title: "Critical Thinking" },
    { title: "Collaboration" },
  ];

  const committees = munCommitteeData;

  const testimonial = munTestimonialData;

  const introText = [
    "NCS MUN provides students with an opportunity to engage with the issues shaping our world while developing the confidence to articulate their perspectives. Through committee sessions, negotiations, and collaborative problem-solving, delegates learn to analyse complex challenges, and defend their positions with evidence while working towards practical solutions.",
    "Following the strong foundation laid by our intra-school conferences, NCS MUN 2026-27 now welcomes participation from schools beyond our campus, creating a broader forum for dialogue and exchange. The conference encourages girl students from Grades 9-12 to examine matters of international significance alongside concerns that affect our nation and local communities.",
    "More than a simulation, NCS MUN is a learning experience that nurtures awareness, empathy, and responsible leadership. We aspire to empower young women who are informed, empathetic, thoughtful in their actions, and committed to making a meaningful difference in the world around them.",
  ];

  const munGalleryItems = [
    {
      title: "NCS MUN",
      attachments: ["NCSR/public/Images/ncs_mun_about.jpeg"],
    },
    {
      title: "Conference Setup",
      attachments: ["NCSR/public/Images/ncs_mun_about.jpeg"],
    },
    {
      title: "Delegate Briefing",
      attachments: ["NCSR/public/Images/ncs_mun_about.jpeg"],
    },
    {
      title: "Committee Session",
      attachments: ["NCSR/public/Images/ncs_mun_about.jpeg"],
    },
  ];

  return (
    <>
      <HeaderMUN></HeaderMUN>
      <div className="breadcrumb">
        <h1>Nirmala Convent School Model United Nations</h1>
        <h6>
          Developing future leaders through debate, negotiation, and global
          awareness.
        </h6>
        <ul>
          <li>
            <a href="/">Home</a> &nbsp; &nbsp;|
          </li>
          <li>NCS MUN &nbsp; &nbsp;|</li>
          <li>Nirmala Convent School Model United Nations</li>
        </ul>
      </div>
      <div className="innerPage mun_ncs-block">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="mun-intro-head">
                <h3>About NCS MUN</h3>
              </div>

              <div className="mun-about-image">
                <img
                  src={`${S3_url}/NCSR/public/Images/ncs_mun_about.jpeg`}
                  alt="NCS MUN"
                  className="img-fluid w-100"
                />
              </div>
              
              <div className="mun-intro-copy">
                {introText.map((text, index) => (
                  <p key={index}>{text}</p>
                ))}
              </div>
            </div>
            <div className = "row message_Container"> 
            <div className="col-lg-6 col-md-12 col-sm-12">
              <div className="mun-principal-invitation" id="principal-invitation">
               
                <h3>Principal’s Message</h3>
                <p>Dear Delegates,</p>
                <p>
                  It gives me great joy to welcome you to Nirmala Convent School,
                  Rajkot, for our first inter-school Model United Nations.
                  Building on the success of our intra-school MUNs, this expanded
                  platform reflects our commitment to learning beyond the
                  classroom, and encouraging research, reasoned debate, confident
                  public speaking, and respectful collaboration to prepare
                  students for leadership and responsible citizenship.
                </p>
                <p>
                  This conference is especially meaningful as it creates space for
                  young women to lead and represent themselves with strength and
                  dignity. I encourage every delegate to engage actively, listen
                  with grace, and contribute sincerely throughout the event. Best
                  wishes to all delegates, organizers, and mentors for a
                  productive and inspiring MUN.
                </p>
                <p>
                  With warm regards,
                  <br />
                  Sr. Betty Mathew
                  <br />
                  Principal, Nirmala Convent School, Rajkot
                </p>
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12">
              <div className="mun-principal-invitation" id="committee-heads-message">
              
                <h3>Committee Heads’ Message</h3>
                <p>Dear Delegates,</p>
                <p>
                  NCS MUN 2026-27 offers a unique platform where preparation
                  meets performance. It is more than an academic exercise; it
                  prepares you for future opportunities and responsibilities by
                  teaching discipline, punctuality, professionalism, and
                  respectful conduct. These are the qualities that matter in
                  every field.
                </p>
                <p>
                  The skills you gain here will stay with you beyond these two
                  days, strengthening your applications, leadership prospects,
                  and careers. Approach the conference with commitment and
                  curiosity, and let it be the start of many opportunities to
                  represent your ideas with confidence and purpose.
                </p>
                <p>
                  With best wishes for a rewarding conference,
                  <br />
                  Rashmi Gandhi and Punam Sharma
                  <br />
                  Committee Heads
                  <br />
                  NCS MUN 2026-27
                </p>
              </div>
            </div>
</div>

            {/* <div className="col-md-12">
              <QuickLink items={skillsDeveloped} />
            </div> */}
            {/* <div className="col-md-12">
              <div className="mun-actions">
                {munButtons.map((item, index) => (
                  <a key={item.title || index} className="mun-btn" href={item.href}>
                    {item.title}
                  </a>
                ))}
              </div>
            </div> */}
            <div className="col-md-12" id="committees">
              <div className="mun-section-head">
                <h3>Explore Committees 2026</h3>
              </div>
              <MunCommittees committees={committees} />
            </div>
            
            <div className="col-md-12" id="previous-muns">
              <div className="container-fluid mun-section-head">
                <h3>Previous MUNs</h3>
              </div>
              <MunGallery items={munGalleryItems} />
            </div>
            
           
            {/* <div className="col-md-12">
              <div className="mun_info_action_link">
                <a className="mun-info-card is-accent" href="#register-now">
                  <h3>Register Now</h3>
                </a>
                <a className="mun-info-card" href="#schedule">
                  <h3>Schedule</h3>
                </a>
                <a className="mun-info-card" href="#brochure">
                  <h3>Download Brochure</h3>
                </a>
                <a className="mun-info-card" href="#contact">
                  <h3>Contact</h3>
                </a>
                <a className="mun-info-card" href="#previous-muns">
                  <h3>Previous MUNs</h3>
                </a>
                <a className="mun-info-card" href="#social-media">
                  <h3>Social Media Pages</h3>
                </a>
              </div>
            </div> */}
          </div>
        </div>
      </div>
     
      <FooterMun />
    </>
  );
};

export default NcsMun;
